import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import FormGroup from '../../elements/formElements/FormGroup';

function SubAffiliateForm({ action, affiliateData, errors, token }) {
    const [affiliate, setAffiliate] = useState({
        medium: '',
        campaign: '',
        content: '',
    });
    const history = useHistory();

    useEffect(() => {
        if (affiliateData) {
            let affiliate = {
                medium: affiliateData.medium ?? '',
                campaign: affiliateData.campaign ?? '',
                content: affiliateData.content ?? '',
            };
            setAffiliate(affiliate);
        }
    }, [affiliateData]);

    function handleSubmit(event) {
        event.preventDefault();
        action(affiliate);
    }

    function cancel() {
        history.goBack();
    }

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <FormGroup
                type={'text'}
                field={'medium'}
                value={affiliate.medium}
                label={'Medium'}
                error={getErrorFor('medium')}
                handleChange={(event) => setAffiliate({ ...affiliate, medium: event.target.value })}
            />
            <FormGroup
                type={'text'}
                field={'campaign'}
                value={affiliate.campaign}
                label={'Campaign'}
                error={getErrorFor('campaign')}
                handleChange={(event) => setAffiliate({ ...affiliate, campaign: event.target.value })}
            />
            <FormGroup
                type={'text'}
                field={'content'}
                value={affiliate.content}
                label={'Content'}
                error={getErrorFor('content')}
                handleChange={(event) => setAffiliate({ ...affiliate, content: event.target.value })}
            />
            <button type="button" onClick={cancel} className="btn btn-secondary">
                Cancel
            </button>
            <button type="submit" className="btn btn-primary">
                Save
            </button>
        </form>
    );
}

export default SubAffiliateForm;
